import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { SharedModule } from '@tv3/shared/shared.module'
import { take } from 'rxjs/operators'
import { WebsitePageDialogComponent } from './website-page-dialog.component'
import { Website } from '@tv3/store/website/website.model'
import { WebsitePageSettings } from '@tv3/store/website/website.types'

@Injectable({
  providedIn: SharedModule,
})
export class WebsitePageDialogService {
  constructor(private dialog: MatDialog) {}

  public open(page: WebsitePageSettings, website: Website) {
    const defaultConfig: MatDialogConfig = {
      width: '680px',
      height: 'auto',
      data: { website, page },
      panelClass: ['variable-modal'],
    }

    return this.dialog.open(WebsitePageDialogComponent, defaultConfig).afterClosed().pipe(take(1))
  }
}
